import { useEffect, useMemo, useState } from "react";
import {
  useChangePrimaryAdminMutation,
  useGetCurrentPrimaryAdminQuery,
  useGetUsersQuery,
} from "./api";
import { DURATION, notify, TYPE } from "@8x8/oxygen-toaster";
import CustomerCard from "@/react/features/customer/card/CustomerCard";
import { errorNotification, useErrorNotification } from "@/react/notifications";
import AdminSearch from "./AdminSearch";
import { Button } from "@/react/styled";
import { OverlaySpinner } from "@/react/components/OverlaySpinner";
import { OuterContainer } from "@/react/features/support-tools/common/styled";
import { ActionStrip, ActionTitle, InnerContainer, Paragraph } from "./styled";
import * as React from "react";

const PrimaryAdminChangePage = () => {
  const {
    data: getCurrentPrimaryAdminData,
    error: getCurrentPrimaryAdminError,
  } = useGetCurrentPrimaryAdminQuery();
  const [changePrimaryAdmin, { isLoading }] = useChangePrimaryAdminMutation();
  const { data: users, error: getUsersError } = useGetUsersQuery();

  const [selectedUser, setSelectedUser] = useState(undefined);

  useErrorNotification(getCurrentPrimaryAdminError);
  useErrorNotification(getUsersError);

  const currentPrimaryAdmin = useMemo(
    () =>
      users?.find(
        (user) => user?.userId === getCurrentPrimaryAdminData?.userId
      ),
    [users, getCurrentPrimaryAdminData]
  );

  useEffect(() => {
    setSelectedUser(currentPrimaryAdmin);
  }, [currentPrimaryAdmin]);

  const handleSubmit = () => {
    changePrimaryAdmin(selectedUser?.userId)
      .then((res) => {
        if (res?.error) {
          errorNotification({ error: "User is already primary admin" });
        } else {
          notify({
            content: res.data.message,
            type: TYPE.success,
            duration: DURATION.INFINITE,
          });
        }
      })
      .catch((error) => {
        errorNotification(error);
      });
  };

  return (
    <OuterContainer>
      <CustomerCard />
      <InnerContainer>
        <ActionTitle>Primary Admin Change</ActionTitle>
        <Paragraph>
          <strong>MENTIONS</strong>
          <ul>
            <li>Select the user from the dropdown below</li>
            <li>
              Click Save to apply - this will trigger the primary admin change
            </li>
            <li>
              Keep in mind there may be multiple primary admins already set
            </li>
          </ul>
          {currentPrimaryAdmin && (
            <>
              <strong>CURRENT PRIMARY ADMIN</strong>
              <ul>
                <li>
                  First Name: <strong>{currentPrimaryAdmin.firstName}</strong>
                </li>
                <li>
                  Last Name: <strong>{currentPrimaryAdmin.lastName}</strong>
                </li>
                <li>
                  Email: <strong>{currentPrimaryAdmin.primaryEmail}</strong>
                </li>
                <li>
                  Login ID: <strong>{currentPrimaryAdmin.loginId}</strong>
                </li>
              </ul>
            </>
          )}
        </Paragraph>
        <ActionStrip>
          <AdminSearch
            currentUser={selectedUser}
            onChange={(user) => setSelectedUser(user)}
          />
          <Button
            marginTop={8}
            onClick={handleSubmit}
            isDisabled={selectedUser === currentPrimaryAdmin}
          >
            Save
          </Button>
        </ActionStrip>
      </InnerContainer>
      {isLoading && <OverlaySpinner />}
    </OuterContainer>
  );
};

export default PrimaryAdminChangePage;
